export const WEBSITE_ENVIRONMENT_URL_CONFIG = {
  LOCAL_HOST: 'localhost',
  DEV_URL: 'http://web.fireflink.com',
  TEST_URL: 'http://webtest.fireflink.com',
  PRE_PROD_URL: 'https://websitepreprod.fireflink.com',
  PRODUCTION1_URL: 'https://webprod.fireflink.com',
  PRODUCTION_URL: 'https://www.fireflink.com',
  ALPHA_URL: 'https://webalpha.fireflink.com',
  BETA_URL: 'http://webbeta.fireflink.com',
  DEV_WEB_SERVICE_URL: 'http://devwswb.fireflink.com',
  FIRE_CLOUD : "http://cloud.fireflink.com",
  STAGING_URL: "https://webstaging.fireflink.com",
  DEV2_URL: "https://webdev2.fireflink.com",
  TEST2_URL: "https://webtest2.fireflink.com",
  TEST3_URL: "https://webtest3.fireflink.com",
};

export default WEBSITE_ENVIRONMENT_URL_CONFIG;
